import React from 'react';
import '../AboutMe.css'; // Import the CSS file

function AboutMe({ id }) {
  return (
    <section id={id}>
      <h2>About Me</h2>
      <p>
        I am a <strong>Senior Full-Stack Developer</strong> with 8+ years in the software industry, specializing in the <strong>Salesforce</strong> ecosystem for the past 5+ years. My core focus is bridging advanced backend architecture (Apex, async logic) with high-performance modern frontends (LWC, SFRA).
      </p>
      <p>
        Dedicated to continuous learning, I specialized in AI with the <strong>University of Helsinki</strong> (Elements of AI) and hold official Salesforce certifications including <strong>Platform Developer, AI Associate, Agentforce Specialist, and Data 360 Consultant</strong>.
      </p>
      <p>
        I thrive in autonomous roles, translating complex business needs into clean, scalable code while helping development teams unblock technical debt.
      </p>
    </section>
  );
}

export default AboutMe;